import React, { useState, useEffect } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import { useNavigate } from 'react-router-dom'; 
import Footer from '../navbar/Footer';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container, Typography, Grid, Card, Divider, FormControl,
  InputLabel, Select, MenuItem, styled, createTheme,
  ThemeProvider, Box, CardMedia, Button
} from '@mui/material';
import moment from 'moment';

const indicesCommerceExterieurData = [
   {
    title: "Indices du commerce extérieur (Base 100= 2013), Troisième trimestre 2025 ",
    principalLink: "/documents/IndicesICE/Indice_CE_T3_2025.pdf",
    image: 'assets/IndicesICE/ice2024_3t.PNG', 
    description: "Les exportations ont augmenté de 52,0 % par rapport à la même période en 2024 (+7,5 %).",
    date: "2025-11-30",
    publicationDate: "2026-02-06"
  },
     {
    title: "Indices du commerce extérieur (Base 100= 2013), Deuxième trimestre 2025 ",
    principalLink: "/documents/IndicesICE/Publication_Indice_T2_2025.pdf",
    image: 'assets/IndicesICE/ice2024_3t.PNG', 
    description: "Au deuxième trimestre 2025, les exportations ont connu une croissance exceptionnelle de 113,8%, surpassant nettement la hausse modérée des importations (+11,9%), ce qui a contribué à une nette amélioration de la balance commerciale.",
    date: "2025-06-30",
    publicationDate: "2025-09-13"
  },
   {
    title: "Indices du commerce extérieur (Base 100= 2013), Premier trimestre 2025 ",
    principalLink: "/documents/IndicesICE/24.06.2025_Publication_Indice_T1_2025.pdf",
    image: 'assets/IndicesICE/ice2024_3t.PNG', 
    description: "Au premier trimestre 2025, le commerce extérieur du Burundi se caractérise par une baisse des importations de 8,3 % en valeur, due notamment au repli des produits minéraux et industriels, tandis que les exportations progressent fortement de 41,5 %, portées par l’essor des produits primaires comme le café, le thé et le niobium.",
    date: "2025-03-30",
    publicationDate: "2025-06-13"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Troisième trimestre 2024 ",
    principalLink: "/documents/IndicesICE/Publication-Indices_3-em-trim-2023.pdf",
    image: 'assets/IndicesICE/ice2024_3t.PNG', 
    description: "Une diminution des importations de 15,9%, tandis que les exportations affichent une progression de 4,9%  due à  la chute des importations de produits minéraux (-30,4%) et de matériel de transport (-32,1%).",
    date: "2024-09-30",
    publicationDate: "2024-11-13"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Deuxième trimestre 2024 ",
    principalLink: "/documents/IndicesICE/Publication-Indices_du-2-em-trim-2024_09.19.pdf",
    image: 'assets/IndicesICE/ice2024_2t.PNG', 
    description: "Une hausse des importations de 8,0%, contre une baisse des exportations de 11,2% par rapport à l'année précédente due à la croissance des importations des biens végétaux (+25,7%) et des métaux communs (+26,4%).",
    date: "2024-06-30",
    publicationDate: "2024-09-13"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Premier trimestre 2024 ",
    principalLink: "/documents/IndicesICE/Indices-du-commerce-exterieur_1er-trim-2024.pdf",
    image: 'assets/IndicesICE/ice2024_1t.PNG', 
    description: "Une hausse des importations de 29,2% et une légère augmentation des exportations de 3,9% par rapport à la même période l'année précédente.",
    date: "2024-03-30",
    publicationDate: "2024-05-13"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Quatrième trimestre 2023 ",
    principalLink: "/documents/IndicesICE/4Publication-Indices_4-em-trim-2023.pdf",
    image: 'assets/IndicesICE/ice2023_4t.PNG', 
    description: "Une augmentation des importations et exportations, respectivement de 20% et 7,8%, par rapport à la même période l'année précédente.",
    date: "2023-12-30",
    publicationDate: "2024-02-13"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Deuxième trimestre 2023",
    principalLink: "/documents/IndicesICE/ICE2-t2-2023t.pdf",
    //image: 'assets/IndicesICE/ice2023_2t.PNG', 
    image: 'assets/IndicesICE/ice2023_4t.PNG', 
    description: "Une augmentation des importations et des exportations par rapport à l'année précédente.",
    date: "2023-06-30",
    publicationDate: "2023-08-13"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Troisième trimestre 2021",
    principalLink: "/documents/IndicesICE/Indices_3ème-trimestre-2021_02.12.2021.doc",
    //image: 'assets/IndicesICE/ice2021_3t.PNG', 
    image: 'assets/IndicesICE/ice2023_4t.PNG', 
    description: "Une forte augmentation des importations (+23,0%) tandis que les exportations chutent de 13,8% par rapport à l'année précédente en faveur des importations des produits minéraux de 52,7%, des produits du règne végétal de 98,1% et du matériel de transport de 11,5%.",
    date: "2021-09-30",
    publicationDate: "2021-12-13"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Deuxième trimestre 2021",
    principalLink: "/documents/IndicesICE/Indices-du-commerce-extérieur_2ème-trim-2021.doc",
   // image: 'assets/IndicesICE/ice2021_2t.PNG', 
   image: 'assets/IndicesICE/ice2023_4t.PNG', 
    description: "Une hausse de 16,1% des importations et de 3,9% des exportations par rapport à l'année précédente due aux importations des produits minéraux de 4,2% des produits du règne végétal de 61,8% et des produits des industries chimiques et connexes de 59,1%.",
    date: "2021-06-30",
    publicationDate: "2021-08-13"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Premier trimestre 2021",
    principalLink: "/documents/IndicesICE/Indices_1er-trim-2021.doc",
    //image: 'assets/IndicesICE/ice2021_1t.PNG', 
    image: 'assets/IndicesICE/ice2023_4t.PNG', 
    description: "Une baisse des importations de 3,5% contre une augmentation des exportation de 66,3% due à la diminution respective observée au niveau des importations des produits minéraux de 17,3%, du matériel de transport de 20,4% et des Matières plastiques ou en caoutchouc et ouvrages en ces matières de 32,6%.",
    date: "2021-03-30",
    publicationDate: "2021-05-28"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Quatrième Trimestre 2020",
    principalLink: "/documents/IndicesICE/Indices-du-CE_-4eme-trimestre-2020-1.doc",
    //image: 'assets/IndicesICE/ice2020_4t.PNG',
    image: 'assets/IndicesICE/ice2023_4t.PNG',  
    description: "Une diminution des importations à hauteur de 10,1%, tandis que les exportations progressent de 11,1% par rapport à l'année précédente en faveur de la diminution respective des importations des produits minéraux de 39,0%, des machines, appareils et accessoires mécaniques et électriques de 18,7% et des produits chimiques ou connexes de 1,3%.",
    date: "2020-12-30",
    publicationDate: "2021-03-02"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Troisième Trimestre 2020",
    principalLink: "/documents/IndicesICE/Indices-du-CE_-3em-trimestre-2020.doc",
    //image: 'assets/IndicesICE/ice2020_3t.PNG',
    image: 'assets/IndicesICE/ice2023_4t.PNG', 
    description: "Une diminution des importations de 10,5% contre une forte augmentation des exportations (+24,4%),",
    date: "2020-09-30",
    publicationDate: "2020-12-02"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Deuxième trimestre 2020",
    principalLink: "/documents/IndicesICE/Indices-du-CE_-_2ème-trimestre.-2020-1.pdf",
    //image: 'assets/IndicesICE/ice2020_2t.PNG',
    image: 'assets/IndicesICE/ice2023_4t.PNG', 
    description: "Une augmentation des importations de 9,3% contre une diminution des exportations de 34,7%  par rapport à 2019.",
    date: "2020-06-30",
    publicationDate: "2020-09-10"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Premier trimestre 2020",
    principalLink: "/documents/IndicesICE/Indices-du-CE_-1er-trimestre-2020-_2_.pdf",
    //image: 'assets/IndicesICE/ice2020_1t.PNG',
    image: 'assets/IndicesICE/ice2023_4t.PNG', 
    description: "Une baisse des importations et des exportations de 5,5% et 32,8% respectivement par rapport à la même période de l'année précédente.",
    date: "2020-03-30",
    publicationDate: "2020-05-29"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Quatrième trimestre 2019",
    principalLink: "/documents/IndicesICE/Indices-du-CE_-4è-trimestre-2019-1.pdf",
    image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une augmentation des importations de 24,8%, principalement à cause des produits minéraux (+44,7%) et du matériel de transport (+36,4%). En revanche, les exportations reculent de 10,9% en raison de la baisse des produits primaires de 18,5%.",
    date: "2019-12-30",
    publicationDate: "2020-02-26"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Troisième trimestre 2019",
    principalLink: "/documents/IndicesICE/Indices-du-CE-_3ème-trimestre-2019-1.doc",
   // image: 'assets/IndicesICE/ice2019_3t.PNG',
   image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une augmentation des importations de 4,1%, contre une diminution des exportations de 18,3% par rapport à 2018.",
    date: "2019-09-30",
    publicationDate: "2019-11-26"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Deuxième trimestre 2019",
    principalLink: "/documents/IndicesICE/Indices-du-commerce-extérieur_2eme-trim-2019.doc",
    //image: 'assets/IndicesICE/ice2019_2t.PNG',
    image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une hausse importations de 10,7%, contre une augmentation des exportations de 16% comparé à la même période de l'année précédente.",
    date: "2019-06-30",
    publicationDate: "2019-08-28"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Premier trimestre 2019",
    principalLink: "/documents/IndicesICE/Indices-du-commerce-extérieur_1er-trim-2019.doc",
    //image: 'assets/IndicesICE/ice2019_1t.PNG',
    image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une augmentation des importations de 17,5%, contre une légère diminution des exportations de 2,4% par rapport à l'année précédente.",
    date: "2019-03-30",
    publicationDate: "2019-05-28"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Quatrième trimestre 2018",
    principalLink: "/documents/IndicesICE/Indices-du-commerce-extérieur_4ème-trim-2018.doc",
   // image: 'assets/IndicesICE/ice2018_4t.PNG',
   image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une baisse des importations de 7,1% et des exportations de 12,7% par rapport à 2017.",
    date: "2018-12-30",
    publicationDate: "2019-02-28"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Troisième trimestre 2018",
    principalLink: "/documents/IndicesICE/Indices-du-Commerce-Extérieur-3èm-trim-2018-VF.doc",
    //image: 'assets/IndicesICE/ice2018_3t.PNG',
    image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une diminution des importations de 2,3% et des exportations significativement plus marquée de 24,9% par rapport à l'année précédente.",
    date: "2018-03-30",
    publicationDate: "2018-12-18"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Deuxième trimestre 2018",
    principalLink: "/documents/IndicesICE/Indices-du-Commerce-Extérieur-2em-trim-2018-1.doc",
   // image: 'assets/IndicesICE/ice2018_2t.PNG',
   image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une dimminution des importations de 5,1% , contre une augmentation des exportations de 17,3%. ",
    date: "2018-06-30",
    publicationDate: "2018-09-14"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Premier trimestre 2018",
    principalLink: "/documents/IndicesICE/Indices-du-Commerce-Extérieur-1er-trim-2018.doc",
    //image: 'assets/IndicesICE/ice2018_1t.PNG',
    image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une forte croissance des importations (+21,1%) et des exportations (+69,8%) comparativement à l'année précédente.",
    date: "2018-03-30",
    publicationDate: "2018-06-01"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Quatrième trimestre 2017",
    principalLink: "/documents/IndicesICE/Indices-du-Commerce-Exterieur-4eme-trim-2017.doc",
    //image: 'assets/IndicesICE/ice2017_4t.PNG',
    image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une augmentation des importations de 59,2% et les exportations de 27,0% par rapport au même trimestre 2016.",
    date: "2017-12-30",
    publicationDate: "2018-02-15"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Troisième trimestre 2017",
    principalLink: "/documents/IndicesICE/Indices-du-Commerce-Extérieur-3ème-trim-2017-1.doc",
    //image: 'assets/IndicesICE/ice2017_3t.PNG',
    image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une hausse modérée des importations (+17,7%) et des exportations (+9,6%) par rapport à 2016.",
    date: "2017-09-30",
    publicationDate: "2017-11-24"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Deuxième trimestre 2017",
    principalLink: "/documents/IndicesICE/Indices-du-Commerce-Extérieur-2ème-trim-2017.doc",
   // image: 'assets/IndicesICE/ice2017_2t.PNG',
   image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une augmentation des importations de 36,8%, contre une hausse des exportations  de (+29,8%).",
    date: "2017-06-30",
    publicationDate: "2017-08-15"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Premier trimestre 2017",
    principalLink: "/documents/IndicesICE/Indices-du-Commerce-Extérieur-1er-trim-2017.docx",
    //image: 'assets/IndicesICE/ice2017_1t.PNG',
    image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une augmentation significative des importations (+18,3%) tandis que les exportations diminuent de 36,8% par rapport à 2016.",
    date: "2017-03-30",
    publicationDate: "2017-05-10"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Troisième trimestre 2016",
    principalLink: "/documents/IndicesICE/Indices-du-Commerce-Extérieur-3ème-trim-2016.docx",
    //image: 'assets/IndicesICE/ice2016_3t.PNG',
    image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une augmentation des valeurs d'importation (+58%) et d'exportation (+104,5%) par rapport au trimestre précédent.",
    date: "2016-09-30",
    publicationDate: "2016-11-21"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Deuxième trimestre 2016",
    principalLink: "/documents/IndicesICE/Indices-du-Commerce-Extérieur-2ème-trim-2016.doc",
    image: 'assets/IndicesICE/ice2016_2t.PNG',
    description: "Une chute des valeurs d'importation et d'exportation respectives de 16,8% et 43,7% par rapport au dernier trimestre.",
    date: "2016-06-30",
    publicationDate: "2016-08-24"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Premier trimestre 2016",
    principalLink: "/documents/IndicesICE/Indices-du-Commerce-Extérieur-1er-trim-2016-bis.doc",
    image: 'assets/IndicesICE/ice2016_1t.PNG',
    description: "Une baisse significative des importations et des exportations de 22,7% et 34,2% respectivement par rapport au trimestre précédent.",
    date: "2016-03-30",
    publicationDate: "2016-06-30"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Troisième trimestre 2015",
    principalLink: "/documents/IndicesICE/Indices-Com-Ext-3ème-trim-2015.doc",
    //image: 'assets/IndicesICE/ice2015_3t.PNG',
    image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une dimunition de l'indice de valeurs unitaires à l’importation est de 93,45 au cours du troisième trimestre de 2015 contre 97,34 au cours du trimestre précédent et une chute des prix à l’exportation de 1,4% d’un trimestre à l’autre et de 18% en glissement annuel.",
    date: "2015-09-30",
    publicationDate: "2015-11-23"
  },
  {
    title: "Indices du commerce extérieur (Base 100= 2013), Quatrième trimestre 2014",
    principalLink: "/documents/IndicesICE/Indices-du-Commerce-Extérieur-4ème-trim-2014.doc",
    //image: 'assets/IndicesICE/ice2014_4t.PNG',
    image: 'assets/IndicesICE/ice2019_4t.PNG',
    description: "Une augmentation des prix d'importation, avec un indice de valeur unitaire s'établissant à 112,0, illustrant une augmentation de plus de 20% par rapport au trimestre précédent, et 10% par rapport à l'année précédente.",
    date: "2014-12-30",
    publicationDate: "2015-03-13"
  },
];
const sortIndicesByDate = (data) => {
  return data.sort((a, b) => new Date(b.date) - new Date(a.date));
};

function IndicesCommerceExterieur() {
  const navigate = useNavigate();
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredIndices, setFilteredIndices] = useState(sortIndicesByDate([...indicesCommerceExterieurData]));
  

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    
    const filtered = year === 'Tous' 
      ? [...indicesCommerceExterieurData] 
      : indicesCommerceExterieurData.filter((indice) => new Date(indice.date).getFullYear() === parseInt(year));

    setFilteredIndices(sortIndicesByDate(filtered));
    setVisibleCount(2);
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: { main: '#388E3C' },
      background: { default: '#f5f5f5' },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
      h4: {
        fontWeight: '600',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <br />
        <br />
        <Container maxWidth="lg" style={{ paddingTop: '14px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Indices du Commerce Extérieur (ICE)
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Les indices du commerce extérieur sont des outils indispensables à l'analyse économique des importations et des exportations. 
            Ils permettent d'obtenir une estimation sur l'évolution des prix et des volumes des biens importés ou exportés.
          </Typography>
          {/* Filtre par année */}
          <FormControl variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année de réalisation</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année de réalisation"
            >
              <MenuItem value="Tous">Tous les indices</MenuItem>
              {[...new Set(indicesCommerceExterieurData.map((indice) => new Date(indice.date).getFullYear()))]
                .sort((a, b) => b - a)
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          {/* Affichage des Indices */}
          <Grid container spacing={1} style={{ marginTop: '5px' }}>
            {filteredIndices.slice(0, visibleCount).map((indice, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={indice.principalLink}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 91, height: 140, m: 2 }}
                        image={indice.image}
                        alt={indice.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={indice.principalLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          {<DownloadIcon />}{indice.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {indice.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(indice.publicationDate).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredIndices.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus d'Indices
            </Button>
          )}

          <Typography variant="body1" align="justify" paragraph style={{ marginTop: '24px', lineHeight: 1.6 }}>
            <strong>Note :</strong> Les Indices du Commerce Extérieur (ICE)sont publiés le <strong>15 de chaque mois</strong>, soit 15 jours après la clôture du mois précédent.
            <br /><br />
            Voici le calendrier des prochaines publications des indices :
            <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
              <li><strong>15 janvier</strong> - Publication des indices du mois de décembre</li>
              <li><strong>15 février</strong> - Publication des indices du mois de janvier</li>
              <li><strong>15 mars</strong> - Publication des indices du mois de février</li>
              <li><strong>15 avril</strong> - Publication des indices du mois de mars</li>
              <li><strong>15 mai</strong> - Publication des indices du mois d'avril</li>
              <li><strong>15 juin</strong> - Publication des indices du mois de mai</li>
              <li><strong>15 juillet</strong> - Publication des indices du mois de juin</li>
              <li><strong>15 août</strong> - Publication des indices du mois de juillet</li>
              <li><strong>15 septembre</strong> - Publication des indices du mois d'août</li>
              <li><strong>15 octobre</strong> - Publication des indices du mois de septembre</li>
              <li><strong>15 novembre</strong> - Publication des indices du mois d'octobre</li>
              <li><strong>15 décembre</strong> - Publication des indices du mois de novembre</li>
            </ul>
          </Typography>
          <Button 
            onClick={() => navigate('/indice')} 
            style={{ marginLeft: '20px', marginTop: '20px', backgroundColor: '#2E7D32', color: '#FFFFFF' }}
          >
            <ArrowBackIcon style={{ marginRight: '8px' }} />
            Retour à la page des indices
          </Button>
        </Container>
        <br/>
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default IndicesCommerceExterieur;